const SCHEMA_ORG_BASE_URL = 'https://schema.org';

export enum SchemaOrgItemType {
    Product = `${SCHEMA_ORG_BASE_URL}/Product`,
}
